/*
 files api
*/

import axios from "../axios/axios";

export function loadFileApi(params) {
  return axios.post('thread/addfile', params);
}

export function referenceAddFileApi(params) {
  return axios.post('users/referenceAddFile', params);
}

export function referenceRemoveFileApi(params) {
  return axios.post('users/referenceRemoveFile', params);
}
